import $axios from "./config";

export default {
  login(payload) {
    return $axios.post("/api/v2/admin/auth/login", payload);
  },
};
